<template>
    <section class="Section LoginSection">
        <img src="/images/CmsData/LoginBackground.jpg" alt=""/>
        <div class="BackgroundOverlay">
            <div class="LoginPanel">
                <div class="LoginLogo"><img src="/images/LoginLogo.png" srcset="/images/LoginLogoRetina.png 2x" alt=""/></div>
                <div class="Form">
                    <div class="FormRow">
                        <div class="FormBoxWide FormInputText Artistic UserField">
                            <div class="Label">&nbsp;</div>
                            <div class="Field"><input placeholder="Username/mail" type="text" v-model="username"/></div>
                        </div>
                    </div>
                    <div class="FormRow">
                        <div class="FormBoxWide FormInputText Artistic PasswordField">
                            <div class="Label">&nbsp;</div>
                            <div class="Field"><input placeholder="Password" type="password" v-model="password" @keypress.enter="CallLogin"/></div>
                        </div>
                    </div>
                    <div class="FormRow">
                        <div class="FormBoxWide FormInputButton">
                            <div class="Label RecoveryPassword">
                                <!-- <a href="/loginpasswordforgot.asp">Hai dimenticato la password?</a> -->
                                <router-link :to="{'name' : 'PasswordRecovery'}">Forgot your password?</router-link>
                            </div>
                            <div class="Field Button"><input type="button" value="Login" @click="CallLogin" /></div>
                        </div>
                    </div>
                    <div class="loader" v-show="isLoading"></div> 
                    <div class="FormRow">
                        <div class="FormBoxWide FormInputButton">
                            <span style="color:#ff0000;font-size:12px;">{{errorMsg}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <CookieBanner/>
</template>

<script>

import CookieBanner from "@/components/CookieBanner.vue"
import AuthService from "@/services/auth.service.js";
import store from '@/store';

export default({
    name: "LoginPage",
    data(){
        return {
            username : "",
            password: "",
            errorMsg: "",
            isLoading: false
        }
    },
    methods:{
        CallLogin(){
            this.isLoading = true;
            this.errorMsg = "";
            this.$store.dispatch({
                type: 'login',
                username: this.username,
                password: this.password
            }).then(
                (data) => {
                    this.$router.push("/home");
                    },
                (error) => {
                    this.isLoading = false;
                    this.errorMsg = "Authentication failed! Incorrect username and password.";
                }
            );
        }
    },
    components: {
        CookieBanner
    },
    beforeRouteEnter (to, from, next){
        let token = store.getters.getToken;
        debugger;
        if(token){
            AuthService.checkLogin(token).then(
                data => {
                    if(data){
                        next({name: "Home"});
                    }
                    else{
                        next();
                    }
                }
            )
            .catch(error => {next()});
        }
        else{
            next();
        }
    }
});
</script>
